var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 12,
    height: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 22C7.28498 22 4.92796 22 3.46349 20.5355C1.99902 19.0711 1.99902 16.714 1.99902 12C1.99902 7.28595 1.99902 4.92893 3.46349 3.46447C4.92796 2 7.28498 2 11.999 2C16.7131 2 19.0701 2 20.5346 3.46447C21.999 4.92893 21.999 7.28595 21.999 12C21.999 16.714 21.999 19.0711 20.5346 20.5355C19.0701 22 16.7131 22 11.999 22ZM15.749 12C15.749 12.4142 15.4132 12.75 14.999 12.75H8.99902C8.58481 12.75 8.24902 12.4142 8.24902 12C8.24902 11.5858 8.58481 11.25 8.99902 11.25H14.999C15.4132 11.25 15.749 11.5858 15.749 12Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinus);
export default __webpack_public_path__ + "static/media/ic_minus.d7d127d4b35df6945bb96ad90f8bbef7.svg";
export { ForwardRef as ReactComponent };